import styled from 'styled-components';
import { typeScale } from 'core/utils';
import { getColor } from 'core/utils/Styles';

export const Wrapper = styled.div`
	background-color: ${getColor('porcelain')};
	margin-top: ${typeScale(2)};
	padding: 16px;
`;

export const ReplyHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: ${typeScale(1)};
`;

export const ReplyName = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: ${typeScale(1)};
`;

export const ReplyNameText = styled.strong`
	font-size: 14px;
`;

export const ReplyDate = styled.strong`
	color: ${getColor('gray4')};
	font-size: 12px;
`;

export const FooterContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
